<template>
  <div class="pc-page pc-login-page pc-password-change-page">
    <pc-status-bar
      class="pc-header"
    />
    <pc-modal-wrapper v-if="isSuccess && !showTokenIsNotValidModal">
      <pc-modal-container
        :show-close="false"
      >
        <div class="pc-modal__content">
          <icu-icon class="pc-success pc-modal__image"></icu-icon>
          <h3> {{ $t('change-password.successful-change') }}</h3>
        </div>
        <div class="pc-modal__actions">
          <pc-button variant="main" :disabled="false" @click="$router.push({name: 'login'})">
            {{ $t('change-password.go-back-to-cabinet') }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
    <pc-modal-wrapper v-else-if="showTokenIsNotValidModal">
      <pc-modal-container :show-close="false">

        <div class="pc-modal__content">
          <icu-icon class="pc-warning pc-modal__image"></icu-icon>
          <h3>{{ $t('notifications.reset-password-wrong-token-text') }}</h3>
        </div>
        <div class="pc-modal__actions vertical">
          <pc-button
            :disabled="false"
            class="p16"
            @click="$router.push({name:'login', query:{resetPassword: true}})"
          >
            {{ $t('notifications.get-link-to-update-password-button-text') }}
          </pc-button>
          <pc-button
            :disabled="false"
            variant="void"
            class="p16"
            @click="$router.push({name:'login'})"
          >
            {{ $t('notifications.return-to-login-button-text') }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
    <pc-modal-wrapper v-else>
      <pc-modal-container :title="$t('change-password.enter-and-confirm-password')" :show-close="false">
        <validation-observer v-slot="{valid}" tag="div" class="pc-modal__form">
          <div class="pc-modal__content">
            <h3>Будь ласка, введiть i повторiть <br />новий пароль</h3>

            <validation-provider
              v-slot="{failedRules, dirty, invalid}"
              :bails="false"
              rules="password|pw_length:8,20|pw_alpha|pw_numeric|pw_symbols"
            >
              <pc-text-input
                v-model="formData.password1"
                type="password"
                :mask-options="{mask:/^\S+(?:\s\S+)*$/}"
                :force-hint="invalid && dirty"
                :label="$t('change-password.enter-new-password')"
                required
                :errors="[failedRules.password,...backendErrors.password1].filter(el => !!el)"
              >
                <template #hint>
                  <password-hint :failed-rules="failedRules" :dirty="dirty" />
                </template>
              </pc-text-input>
            </validation-provider>
            <validation-provider v-slot="{errors}" :rules="{pw_confirm: formData.password1}">
              <pc-text-input
                v-model="formData.password2"
                :label="$t('change-password.re-enter-password')"
                required
                type="password"
                :errors="errors"
              />
            </validation-provider>
          </div>
          <div class="pc-modal__actions">
            <pc-button
              variant="main"
              class="password-change__button"
              :disabled="!valid"
              @click="resetPassword"
            >
              {{ $t('change-password.change-password') }}
            </pc-button>
          </div>


        </validation-observer>
      </pc-modal-container>
    </pc-modal-wrapper>
  </div>
</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import ModalContainer from '@/components/modals/ModalContainer.vue'
import IcuButton from '@/components/common/IcuButton.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import CommonModal from '@/components/modals/CommonModal.vue'
import PasswordHint from '@/components/misc/PasswordHint.vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import { api } from '@/api/api.js'
import {constants} from '@/constants'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'
import PcTextInput from '@/components/inputs/PcTextInput'
import PcButton from '@/components/common/PcButton'
import PcStatusBar from '@/components/views/PrivateCabinet/PcStatusBar'
import IcuIcon from '@/components/common/IcuIcon'

export default {
  name: 'ResetPassword',
  components: {
    IcuIcon,
    PcStatusBar,
    PcButton,
    PcTextInput,
    PcModalContainer,
    PcModalWrapper, PasswordHint, ValidationProvider, ValidationObserver, CommonModal, TextInput, IcuButton, ModalContainer, ModalWrapper },
  data() {
    return {
      isSuccess: false,
      formData: {
        password1: '',
        password2: '',
        uidb64: '',
        token: ''
      },
      backendErrors: {},
      isTokenValid: false,
      showTokenIsNotValidModal: false
    }
  },
  watch:{
    'formData.password1'(){
      this.backendErrors = []
    }
  },
  async mounted() {
    const {uid, token} = this.$route.query
    try {
      const { data } = await api.auth.checkResetToken(uid, token)
      this.formData.uidb64 = data.uidb64
      this.formData.token = data.token
      this.isTokenValid = true
    } catch (e) {
      const err = e.response.data
      if (err._error_code === constants.ERROR_CODES.resetPasswordTokenIsNotValid){
        this.showTokenIsNotValidModal = true
      } else {
        this.$toast.error(this.$t('notifications.something-went-wrong-recheck'))
      }
    }
  },
  methods: {
    async resetPassword() {
      try {
        await api.auth.resetPassword(this.formData)
        this.isSuccess = true
      } catch (e) {
        this.backendErrors = e.response.data
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-password-change-page {
  .p16 {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.password-change {
  display: flex;
  flex-direction: column;
  flex: 1;

  &__button {
    @media (max-width: #{$mobile}) {
      margin-top: auto;
    }
  }

  &-form {
    display: grid;
    grid-row-gap: 32px;
    margin-bottom: 80px;
  }

  &-hints {
    margin-top: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 2px;
    grid-column-gap: 12px;

    &__hint {
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      color: $gray-2;

      &.valid {
        color: $active-green;
      }
    }
  }
}
</style>
